<template>
  <FileUploader :text="'Прикачване на файл'" :allowedFiles="'image/jpeg, image/png, application/pdf'"
                @file-upload="uploadFile"/>
</template>

<script>
import FileUploader from "@/shared/components/form/FileUploader";

export default {
  name: 'DocumentUploader',
  components: {FileUploader},
  data() {
    return {
      file: null
    }
  },
  methods: {
    uploadFile(fileTemp) {
      this.file = fileTemp;
    }
  },
  watch: {
    file: {
      handler() {
        if (this.file.size > 999999) {
          alert('Размерът на файла трябва да бъде до 1MB!');
        } else {
          this.$emit('file-upload', this.file);
        }
      },
      deep: true
    }
  }
}
</script>

<style>
</style>
